import React from 'react'; 
import robotpic from '@iso/assets/images/rob.png';
import IntlMessages from '@iso/components/utility/intlMessages';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
           return (
        <div style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "20px"
        }}>
          <img src={robotpic} width={50}  /> 
          <h2 style={{ marginBottom: "10px" }}><IntlMessages id="error.boundary.naslov"/> </h2>
          <p style={{ marginBottom: "20px" }}>
            <IntlMessages id="error.boundary.opis"/> 
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#4670a2",
              color: "white",
              cursor: "pointer"
            }}
          >
            <IntlMessages id="error.boundary.botun"/> 
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
